import React, { FC } from "react"
import { Dialog } from "@headlessui/react"
import clsx from "clsx"
import { FlexBox } from "@components/wrapper"

export interface BasicModalProps {
  show: boolean
  onClose: () => void
  backdropClassName?: string
  children: any
}

export const BasicModal: FC<BasicModalProps> = ({
  show = false,
  onClose,
  backdropClassName,
  children,
}) => {
  return (
    <Dialog
      as="div"
      className="fixed inset-0 z-[1000] overflow-y-auto"
      onClose={onClose}
      open={show}
    >
      <FlexBox className="min-h-screen px-4" justify="center" align="center">
        <Dialog.Overlay className={clsx("fixed inset-0 bg-backdrop", backdropClassName)} />
        {children}
      </FlexBox>
    </Dialog>
  )
}
